export enum ACCREDIBLE_WIZARD_STEP_STATE {
  VALIDATED = 'validated',
  CURRENT = 'current',
  PENDING = 'pending',
}

export interface AccredibleWizardStep {
  label: string;
  state?: ACCREDIBLE_WIZARD_STEP_STATE;
}
